// src/data/constants.js

export const ROLES = ['Manager', 'Sales', 'Compliance', 'Support'];

export const PERMISSIONS_MATRIX = [
  { id: 1, label: 'View Financials', roles: ['Manager', 'Sales', 'Compliance'] }, 
  { id: 2, label: 'Edit/Approve KYC', roles: ['Manager', 'Compliance'] },
  { id: 3, label: 'Freeze Account', roles: ['Manager', 'Compliance'] },
  { id: 4, label: 'Unfreeze Account (2FA)', roles: ['Manager'] },
  { id: 5, label: 'View Sensitive PII', roles: ['Manager', 'Compliance'] }
];

export const COMM_TEMPLATES =  {
    email: [
        { id: 'custom', label: 'Custom Message', subject: '', body: '' },
        { id: 'welcome', label: 'Welcome to Nommia', subject: 'Welcome to Nommia - Account Ready', body: 'Dear Client,\n\nWe are delighted to have you on board. Your trading account is now fully active.\n\nRegards,\nNommia Team' },
        { id: 'kyc_remind', label: 'KYC Reminder', subject: 'Action Required: Verify Identity', body: 'Dear Client,\n\nPlease complete your identity verification to unlock full trading features. You can upload documents directly in your portal.\n\nRegards,\nCompliance Team' },
        { id: 'margin', label: 'Margin Call Warning', subject: 'Urgent: Margin Call Warning', body: 'Dear Client,\n\nYour account margin level has dropped below 100%. Please top up funds immediately to avoid liquidation.\n\nRegards,\nRisk Team' }
    ],
    whatsapp: [
        { id: 'custom', label: 'Custom Message', body: '' },
        { id: 'hello', label: 'Greeting', body: 'Hello! This is your dedicated account manager from Nommia. How can I assist you today?' },
        { id: 'doc_request', label: 'Document Request', body: 'Hi, we noticed your ID document was blurry. Could you please snap a clear photo and send it here?' },
        { id: 'urgent', label: 'Urgent Update', body: 'Hi, please check your email for an urgent update regarding your account security.' }
    ]
};

export const SYSTEM_TRIGGERS = [
    { id: 'REGISTRATION', label: 'New User Registration' },
    
    // --- The Master Account Verification Trigger ---
    { id: 'KYC_APPROVED', label: 'Account Fully Verified (Final)' },
    
    // --- Specific Document Approvals ---
    { id: 'POI_APPROVED', label: 'Proof of ID Approved' },
    { id: 'POA_APPROVED', label: 'Proof of Address Approved' },
    
    // --- Document Rejections ---
    { id: 'DOCUMENT_REJECTED', label: 'Individual Document Rejected (General)' },
    { id: 'DOCUMENT_REJECTED_MISMATCH', label: 'Document Rejected (Details Mismatch)' },
    { id: 'DOCUMENT_REJECTED_QUALITY', label: 'Document Rejected (Quality/Visibility)' },
    { id: 'DOCUMENT_REJECTED_EXPIRED', label: 'Document Rejected (Invalid/Expired)' },

    // --- Legacy KYC Triggers ---
    { id: 'KYC_SUBMITTED', label: 'KYC Documents Submitted' },
    { id: 'KYC_REJECTED', label: 'KYC Rejected (Legacy)' },
    { id: 'KYC_REJECTED_MISMATCH', label: 'KYC Rejected - Details Mismatch (Legacy)' },
    { id: 'KYC_REJECTED_QUALITY', label: 'KYC Rejected - Quality & Visibility (Legacy)' },
    { id: 'KYC_REJECTED_EXPIRED', label: 'KYC Rejected - Invalid or Expired (Legacy)' },
    
    // --- Operations Triggers ---
    { id: 'DEPOSIT_FIRST', label: 'First Deposit Success' },
    { id: 'WITHDRAWAL_REQUEST', label: 'Withdrawal Requested' },
    { id: 'MARGIN_CALL', label: 'Margin Level < 50%' },
    { id: 'STOP_OUT', label: 'Stop Out Executed' },
    { id: 'DORMANT_30', label: 'Inactive for 30 Days' },
    { id: 'TICKET_INACTIVE_14D', label: 'Ticket Inactive > 14 Days' }
];